import './menu-microsoft-365.scss';

/* global t */

/**
 * Menu Microsoft 365 component - handles tenant list in sidebar.
 */
export default () => {
	const element = document.querySelector( '[data-component="menu-microsoft-365"]' );

	if ( !element ) {
		return;
	}

	const config = element.dataset.config ? JSON.parse( element.dataset.config ) : {
	};
	const tenantId = config.tenantId || 0;

	let orderColumn = $( '.domain-menu .domain__caption .domain__col[data-sort-default="1"]' ).data( 'sort' );
	let sortOrder = $( '.domain-menu .domain__caption .domain__col[data-sort-default="1"]' ).data( 'sortorder' );

	/**
	 * Resets the tenants table.
	 */
	function resetTenantForm () {
		$( '.domains-table' ).empty();
	}

	/**
	 * Loads tenants from the server.
	 *
	 * @param {jQuery|string} searchForm - Optional search form element.
	 */
	function loadTenants ( searchForm = '' ) {
		resetTenantForm();

		let searchPhrase = '';
		const status = [];

		if ( searchForm ) {
			searchPhrase = $( searchForm ).find( 'input[name=input_search]' ).val();

			if ( $( searchForm ).find( '.dropdown-item.status_child[data-status=1]' ).hasClass( 'active' ) ) {
				status.push( 1 );
			}

			if ( $( searchForm ).find( '.dropdown-item.status_child[data-status=2]' ).hasClass( 'active' ) ) {
				status.push( 2 );
			}
		}

		$.ajax( {
			type: 'POST',
			dataType: 'json',
			url: '/cp/modules/microsoft-365/json/load-tenants.php',
			data: {
				search_phrase: searchPhrase,
				status,
				sort: {
					column: orderColumn,
					sortorder: sortOrder,
				},
			},
			success ( data ) {
				if ( data.details.count > 0 ) {
					$.each( data.details.tenants, function ( key, tenant ) {
						const statusClass = Number( tenant.status_id ) === 3 ? 'text-warning' : '';

						$( '.domains-table' ).append( `
							<div class="domain__item position-relative ${tenantId === tenant.id ? 'is-active' : ''}">
								<div class="d-flex flex-wrap mx-n2">
									<a class="domain__col domain__col--domain align-items-center px-2" href="${tenant.url}">
										<div class="d-flex align-self-start">
											<div>
												<i class="fas fa-globe ${statusClass}"></i>
											</div>
											<div>
												<div>${tenant.tenant}</div>
											</div>
										</div>
									</a>
									<div class="domain__col domain__col--date px-2">${tenant.subscriptions}</div>
								</div>
								<a href="${tenant.url}" class="domain__edit">
									<i class="fas fa-edit"></i>
								</a>
							</div>
						` );
					} );
				} else {
					$( '.domains-table' ).append( `
						<div class="domain__item position-relative">
							<div class="d-flex flex-wrap mx-n2">
								<div class="snapshot__col domain__col--domain d-flex flex-wrap align-items-center px-2">
									<i class="fas fa-times-circle text-warning menu-microsoft-365-icon"></i> ${t( 'Geen tenants' )}
								</div>
							</div>
						</div>
					` );
				}
			},
			error ( xhr ) {
				$.toast( {
					heading: t( 'Foutmelding' ),
					text: xhr.responseJSON?.status_description || t( 'Er is een fout opgetreden.' ),
					position: 'bottom-left',
					loaderBg: '#87888a',
					icon: 'error',
					hideAfter: 6000,
					stack: 6,
				} );
			},
		} );
	}

	// Search form dropdown item click handler.
	$( '.search-form .dropdown-item' ).on( 'click', function () {
		const searchForm = $( this ).parent();

		setTimeout( function () {
			loadTenants( searchForm );
		}, 100 );
	} );

	// Search form submission handler.
	$( '.search-form' ).on( 'submit', function ( e ) {
		const searchForm = $( this );

		e.preventDefault();
		$( '.search-form .dropdown-menu' ).dropdown( 'hide' );
		loadTenants( searchForm );
	} );

	// Sorting handler.
	$( '.domain-menu .domain__caption .domain__col' ).click( function () {
		// Reset all sorting.
		$( '.domain-menu .domain__caption .domain__col' ).not( this ).data( 'sortorder', '' );
		$( '.domain__caption .domain__col .sort i' ).removeClass( 'active' );

		orderColumn = $( this ).data( 'sort' );
		sortOrder = $( this ).data( 'sortorder' ) === 'asc' ? 'desc' : 'asc';

		$( this ).data( 'sortorder', sortOrder );
		$( this ).find( `.sort .${sortOrder}` ).addClass( 'active' );

		loadTenants();
	} );

	// Load tenants on page load.
	loadTenants();
};

